module.exports = __webpack_public_path__ + "media/09 cheer for.5a215de7.mp3";